import { toFixed } from '../../formatters'
import { sortStrings } from '../../util/sorters/sort-strings'
import { Tenant } from '../Tenants/models'

export const filterOption = (searchInput: string, searchOption: any) =>
  searchOption.children.toLowerCase().includes(searchInput.toLowerCase())

export const sortByName = (firstTenant: Tenant, secondTenant: Tenant) =>
  sortStrings(firstTenant.name, secondTenant.name)

export const formatRate = ({ value }) => (value ? toFixed({ value }) : value)

export const convertRowToColumnIfNeeded = (values) => {
  if (values.length === 1) {
    const rowValues = values.pop()
    rowValues.forEach((value) => values.push([value]))
  }
}

export const tenors = [
  { tenor: '1M', label: '1 Month' },
  { tenor: '2M', label: '2 Months' },
  { tenor: '3M', label: '3 Months' },
  { tenor: '4M', label: '4 Months' },
  { tenor: '5M', label: '5 Months' },
  { tenor: '6M', label: '6 Months' },
  { tenor: '7M', label: '7 Months' },
  { tenor: '8M', label: '8 Months' },
  { tenor: '9M', label: '9 Months' },
  { tenor: '10M', label: '10 Months' },
  { tenor: '11M', label: '11 Months' },
  { tenor: '12M', label: '12 Months' },
  { tenor: '2Y', label: '2 Years' },
  { tenor: '3Y', label: '3 Years' },
  { tenor: '4Y', label: '4 Years' },
  { tenor: '5Y', label: '5 Years' },
  { tenor: 'YTD', label: 'YTD' },
]
